import * as Linking from "expo-linking";
import { Platform } from "react-native";

export const openExternalLink = (url: string) => {
  if (Platform.OS === "web") {
    window.open(url, "_blank", "noopener noreferrer");
  } else {
    Linking.openURL(url);
  }
};
